import { render, staticRenderFns } from "./UserInfoTabs.vue?vue&type=template&id=431a13e6"
import script from "./UserInfoTabs.vue?vue&type=script&lang=js"
export * from "./UserInfoTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports